import { render } from "./CustomerMasterPage.vue?vue&type=template&id=3e0ae497&scoped=true&ts=true"
import script from "./CustomerMasterPage.vue?vue&type=script&lang=ts"
export * from "./CustomerMasterPage.vue?vue&type=script&lang=ts"

import "./CustomerMasterPage.vue?vue&type=style&index=0&id=3e0ae497&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0ae497"]])

export default __exports__